import { FC } from 'react';

import { Icon, StaticDateSpan } from '@myn/mui';

import { DateFieldProps } from '../types.js';

type Props = Pick<DateFieldProps, 'value' | 'scale'>;

const DateVariant: FC<Props> = ({ value, scale }) => {
  if (!value) {
    return null;
  }

  return (
    <>
      <Icon component="Calendar" color="inherit" sx={{ zoom: scale }} />
      <StaticDateSpan date={value} />
    </>
  );
};

export default DateVariant;
